import { useTheme } from "@material-ui/core/styles";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import { TabContext, TabPanel } from "@material-ui/lab";
import clsx from "clsx";
import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import { BrowserRouter as Router, Switch } from "react-router-dom";
import Dialog from "../../components/common/Dialog";
import PendingRequests from "../../components/PendingRequests/PendingRequests";
import Principal from "../../components/Principal/Principal";
import RegisterExit from "../../components/RegisterExit/RegisterExit";
import useBreakpoint from "../../hooks/useBreakpoint";
import usePendingRequest from "../../hooks/usePendingRequest";
import useScan from "../../hooks/useScan";
import { useStore } from "../../hooks/useStore";
import useTabs from "../../hooks/useTabs";
import { useTranslation } from "../../hooks/useTranslation";
import DrawerMain from "../../layout/DrawerMain/DrawerMain";
import TabBar from "../../layout/TabBar/TabBar";
import TabEvents from "../../layout/TabEvents/TabEvents";
import ToScan from "../../layout/ToScan/ToScan";
import {
  configOnEditing,
  configReset,
} from "../../redux/actions/configActions";
import { getAllPendingRequest } from "../../redux/actions/pendingRequestAction";
import { tabShowLimit } from "../../redux/actions/tabActions";
import ProtectedRoutes from "../../routes/ProtectedRoutes";
import { RoutePaths } from "../../utils/Items";
import { customTheme } from "../../utils/ThemeConfig";
import { useStyles } from "./DashboardStyles";
import useRegisterExit from "../../hooks/useRegisterExit";
import useValidation from "../../hooks/useValidation";

const Dashboard = () => {
  const classes = useStyles();
  const { configStore } = useStore();
  const theme = useTheme();
  const { BundleKey, t } = useTranslation();
  const dispatch = useDispatch();
  const matches = useMediaQuery(theme.breakpoints.up("md"));
  const { convertDataTable } = usePendingRequest();
  const { authStore, pendingRequestStore, tabStore } = useStore();
  const { isMobile } = useBreakpoint();
  const { scanQrPdfScanner, result, reset } = useScan();
  const { addTabWithStore, autoChangeTab } = useTabs();
  const { searchExit } = useRegisterExit();
  const { isLoadUserTab } = useValidation();
  const { fetchPeopleInside } = useRegisterExit();


  useEffect(() => {
    if (pendingRequestStore.listPendingRequest.length === 0) {
      dispatch(getAllPendingRequest(authStore.token, convertDataTable));
    }
  }, [JSON.stringify(pendingRequestStore.listPendingRequest)]);

  const onCloseExit = () => {
    dispatch(configOnEditing({ show: false }));
  };

  const onSubmitExit = () => {
    if (configStore.modalEditing.action) {
      configStore.modalEditing.action();
      dispatch(configReset());
    }
  };

  const onCloseTabLimit = () => {
    dispatch(tabShowLimit(false));
  };

  const unloadEvent = (ev: any) => {
    ev.preventDefault();
    if (ev) {
      ev.returnValue = "";
    }
    return "";
  };

  useEffect(() => {
    if (tabStore.tabs.length !== 0)
      window.addEventListener("beforeunload", unloadEvent);
    else window.removeEventListener("beforeunload", unloadEvent);
    return () => {
      window.removeEventListener("beforeunload", unloadEvent);
    };
  }, [tabStore.tabs.length]);

  useEffect(() => {
    if (result) {
      isLoadUserTab(result).then((response) => {
        if (response.isLoad) {
          autoChangeTab(response.tabIndex);
        } else {
          if (configStore.pathname !== RoutePaths.RegisterExit)
            addTabWithStore(result, { eventType: "in" });
          else searchExit(result);
        }
      });
    }
    reset();
  }, [result]);

  useEffect(() => {
    document.addEventListener("keydown", scanQrPdfScanner);
    fetchPeopleInside()

    return () => {
      document.removeEventListener("keydown", scanQrPdfScanner);
    };
  }, []);

  return (
    <div className={classes.root}>
      <Router>
        <DrawerMain />
        <div className={clsx(classes.expand, { [classes.rootMd]: matches })}>
          <TabContext value={tabStore.tabSelectIndex}>
            <TabBar />
            <TabPanel
              value="-1"
              style={{
                height: "100%",
                marginTop: isMobile
                  ? customTheme.mixins.tabbar.heightMobile
                  : customTheme.mixins.tabbar.height,
                padding: 0,
              }}
            >
              <Switch>
                <ProtectedRoutes
                  path={RoutePaths.Dashboard}
                  redirect={RoutePaths.SearchManualInput}
                  exact
                  component={Principal}
                />
                <ProtectedRoutes
                  path={RoutePaths.SearchManualInput}
                  component={Principal}
                />
                <ProtectedRoutes
                  path={RoutePaths.RegisterExit}
                  component={RegisterExit}
                />
                <ProtectedRoutes path={RoutePaths.Scan} component={ToScan} />
                <ProtectedRoutes
                  path={RoutePaths.PendingRequest}
                  component={PendingRequests}
                />
              </Switch>
            </TabPanel>
            <TabEvents />
          </TabContext>
        </div>
      </Router>
      <Dialog
        open={configStore.modalEditing.show || false}
        title={configStore.modalEditing.title}
        labelNo={configStore.modalEditing.labelNo || t(BundleKey.ACTION_NO)}
        labelYes={configStore.modalEditing.labelYes || t(BundleKey.ACTION_YES)}
        onClose={onCloseExit}
        onSubmit={onSubmitExit}
      />
      <Dialog
        open={tabStore.isMax}
        labelYes={t(BundleKey.ACTION_ACCEPT)}
        onClose={onCloseTabLimit}
      >
        {t(BundleKey.TAB_MAXLIMIT_MESSAGE)}
      </Dialog>
    </div>
  );
};
export default Dashboard;
